export class InvitationCode {
  public code: string;
  public redeemable: boolean;
  public cancelled: boolean;
  public invitationCodeDetails?: IInvitationCodeDetails;
}

export enum InvitationCodeType {
  familyPlan = 'familyPlan',
}

export interface IInvitationCodeDetails {
  type: InvitationCodeType;
  familyPlanDetails?: IFamilyPlanInvitationCodeDetails;
}

export interface IFamilyPlanInvitationCodeDetails {
  planOwnerUserProfileId: string;
  invitedEmail: string;
}
